"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatRoom = void 0;
const core_1 = require("@hyper-hyper-space/core");
const core_2 = require("@hyper-hyper-space/core");
const core_3 = require("@hyper-hyper-space/core");
const ChatMessage_1 = require("./ChatMessage");
// A simple chat room. Anyone who knows its hash may join it.
class ChatRoom extends core_2.HashedObject {
    constructor() {
        super();
        this.setRandomId();
        this.addDerivedField('topic', new core_3.MutableReference());
        this.addDerivedField('messages', new core_3.MutableSet());
    }
    init() {
    }
    async validate(_references) {
        return this.getId() !== undefined &&
            this.checkDerivedField('topic') &&
            this.checkDerivedField('messages');
    }
    say(author, text) {
        var _a;
        let message = new ChatMessage_1.ChatMessage(author, text);
        (_a = this.messages) === null || _a === void 0 ? void 0 : _a.add(message).then(() => {
            this.getStore().save(this.messages);
        });
        //this.messages?.saveQueuedOps();
    }
    getMessages() {
        if (this.messages === undefined) {
            throw new Error('The chat room has not been initialized, messages are unavailable.');
        }
        return this.messages;
    }
    async startSync() {
        var _a, _b, _c;
        let resources = this.getResources();
        if (resources === undefined) {
            throw new Error('Cannot start sync: resources not configured.');
        }
        if (((_a = resources.config) === null || _a === void 0 ? void 0 : _a.id) === undefined) {
            throw new Error('Cannot start sync: local identity has not been defined.');
        }
        if (resources.store === undefined) {
            throw new Error('Cannot start sync: a local store has not been configured.');
        }
        this._node = new core_1.PeerNode(resources);
        this._node.broadcast(this);
        this._node.sync(this);
        (_b = this.topic) === null || _b === void 0 ? void 0 : _b.loadAndWatchForChanges();
        (_c = this.messages) === null || _c === void 0 ? void 0 : _c.loadAndWatchForChanges();
    }
    async stopSync() {
        var _a, _b;
        (_a = this._node) === null || _a === void 0 ? void 0 : _a.stopBroadcast(this);
        (_b = this._node) === null || _b === void 0 ? void 0 : _b.stopSync(this);
    }
    getClassName() {
        return ChatRoom.className;
    }
}
exports.ChatRoom = ChatRoom;
ChatRoom.className = 'p2p-chat/v0/model/ChatRoom';
core_2.HashedObject.registerClass(ChatRoom.className, ChatRoom);
//# sourceMappingURL=ChatRoom.js.map